
  
// Script Généré le : 10/01/2026 10:38:10 via ModelGenerator.nt
//  SuiviAchatsUpdateParameters.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\SuiviAchatsUpdateParameters.ts

export class SuiviAchatsUpdateParameters {

  // int SupplierId
  public SupplierId: number=0;

  // bool TopNational
  public TopNational: boolean=false;

  // bool TopGroupement
  public TopGroupement: boolean=false;

  // bool TopConcurrent
  public TopConcurrent: boolean=false;

  // string[] DivSAPs
  public DivSAPs: string[]=[];

  // DateTime? FrameworkContractDate
  public FrameworkContractDate?: Date=null;

  // int? FrameworkContractPafDocId
  public FrameworkContractPafDocId?: number=null;
}